{
  "schemaVersion": "cogo.terminology-index.v1",
  "description": "Compiled index of coogo DEFINED terminology. Derived from the ontology sources listed in `sources`; never authored directly. Retrieval and the ambiguity feedback loop resolve user phrasing against THIS index — no vocabulary is minted at runtime.",
  "sources": [
    "ontology/element-types.json",
    "ontology/action-types.json",
    "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
    "ontology/event-types.json",
    "ontology/flow-step-types.json",
    "ontology/knowledge-units.seed.json",
    "ontology/platform-decision-terms.seed.json",
    "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
    "packages/cogo-kg-browser/fixtures/expression-prefix-v1.ttl",
    "ontology/applications/bakery-storefront-template.application-terminology.json",
    "ontology/applications/fixture-demo-app.application-terminology.json",
    "ontology/applications/wonbanking-domain-glossary.application-terminology.json"
  ],
  "scopes": [
    "app:bakery-storefront",
    "app:fixture-task3-demo",
    "app:wonbanking",
    "platform"
  ],
  "counts": {
    "action": 99,
    "element-type": 195,
    "event": 14,
    "expression-prefix": 9,
    "flow-step": 10,
    "flow-trigger": 7,
    "param-key": 128,
    "surface-term": 9
  },
  "scopeCounts": {
    "app:bakery-storefront": {
      "application-term": 1
    },
    "app:fixture-task3-demo": {
      "application-term": 2
    },
    "app:wonbanking": {
      "application-term": 25
    },
    "platform": {
      "action": 99,
      "element-type": 195,
      "event": 14,
      "expression-prefix": 9,
      "flow-step": 10,
      "flow-trigger": 7,
      "param-key": 128,
      "surface-term": 9
    }
  },
  "total": 499,
  "entries": [
    {
      "id": "addTableRow",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "data",
      "description": "Add a new row to a table array"
    },
    {
      "id": "aiCancel",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "ai",
      "description": "Cancel active AI streaming request via AbortController"
    },
    {
      "id": "analyticsEvent",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "utility",
      "description": "Send analytics event"
    },
    {
      "id": "applyReportDesignTheme",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "ui",
      "description": "Apply a report design-system theme by changing Cogo JSON token references or preview design state without changing report content."
    },
    {
      "id": "batchAction",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "flow",
      "description": "Execute multiple actions as a batch"
    },
    {
      "id": "callFlow",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "flow",
      "description": "Invoke another flow (local or cross-block)"
    },
    {
      "id": "cfAiGateway",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "cloudflare",
      "description": "CF AI Gateway LLM request caching/rate-limit/logging"
    },
    {
      "id": "cfDurableObject",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "cloudflare",
      "description": "CF Durable Object create/get/put/delete + alarm"
    },
    {
      "id": "cfKv",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "cloudflare",
      "description": "CF KV get/set/delete/list"
    },
    {
      "id": "cfR2",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "cloudflare",
      "description": "CF R2 upload/download/list/delete"
    },
    {
      "id": "clipboardRead",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "utility",
      "description": "Read from clipboard"
    },
    {
      "id": "cogo.formula.dependencies",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "data",
      "description": "Extract cell, range, and named-reference dependencies from a formula."
    },
    {
      "id": "cogo.formula.evaluate",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "data",
      "description": "Evaluate an Excel-compatible formula through the Cogo runtime formula engine."
    },
    {
      "id": "compute",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "data",
      "description": "Compute expression and store result"
    },
    {
      "id": "computeDateRange",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "utility",
      "description": "Compute date range from preset"
    },
    {
      "id": "computeField",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "data",
      "description": "Computes a derived field on array items"
    },
    {
      "id": "conditionalDelay",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "flow",
      "description": "Wait while condition is true"
    },
    {
      "id": "confirmAction",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "ui",
      "description": "Show a blocking confirmation dialog (e.g. before placeOrder). Halts the ActionFlow if user cancels; subsequent steps only run on confirm. Wave 4 R6 — cofo:Checkout AC4.3 review-step confirm gate."
    },
    {
      "id": "copyToClipboard",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "utility",
      "description": "Copy text to clipboard"
    },
    {
      "id": "cropImage",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "media",
      "description": "Crop an image through a native/image-processing adapter."
    },
    {
      "id": "cryptoAction",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "crypto",
      "description": "Cryptocurrency operation"
    },
    {
      "id": "csvExport",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "media",
      "description": "Export data as CSV file"
    },
    {
      "id": "debounceAction",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "utility",
      "description": "Debounce action execution"
    },
    {
      "id": "delay",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "flow",
      "description": "Wait for specified duration"
    },
    {
      "id": "deleteTableRow",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "data",
      "description": "Delete a row from a table array by index"
    },
    {
      "id": "dispatchStoreAction",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "data",
      "description": "Dispatch a named handler to the block's store — used in Studio blocks to trigger UI state mutations (open drawer, collapse, undo, redo, etc.)"
    },
    {
      "id": "downloadAction",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "media",
      "description": "Download a file"
    },
    {
      "id": "emitEvent",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "event",
      "description": "Emit a named app event directly without wrapping one atomic action in an ActionFlow"
    },
    {
      "id": "fileUpload",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "media",
      "description": "Upload a file"
    },
    {
      "id": "firebaseAuth",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "auth",
      "description": "Firebase authentication operation — DEPRECATED: use supabaseAuth instead"
    },
    {
      "id": "firestoreAction",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "data",
      "description": "Firestore CRUD operation — DEPRECATED: use supabaseQuery instead"
    },
    {
      "id": "formValidate",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "form",
      "description": "Validate form fields against rules"
    },
    {
      "id": "geminiAction",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "utility",
      "description": "Call Gemini LLM API"
    },
    {
      "id": "geminiFunctionCall",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "ai",
      "description": "Gemini function calling agent pattern"
    },
    {
      "id": "geminiStream",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "ai",
      "description": "Gemini streaming response with token-by-token output"
    },
    {
      "id": "geminiVision",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "ai",
      "description": "Gemini vision multimodal image analysis"
    },
    {
      "id": "geolocation",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "utility",
      "description": "Get device location"
    },
    {
      "id": "goLink",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "navigation",
      "description": "Open external URL"
    },
    {
      "id": "googleFcm",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "google",
      "description": "Send push notification via FCM CF proxy"
    },
    {
      "id": "googleGmail",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "google",
      "description": "Send email via Gmail CF proxy"
    },
    {
      "id": "graphqlAction",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "data",
      "description": "Execute GraphQL query or mutation"
    },
    {
      "id": "groupBy",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "data",
      "description": "Groups array items by a specified key"
    },
    {
      "id": "invokeCallback",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "ui",
      "description": "Invoke a host-registered block callback by name."
    },
    {
      "id": "invokeNativeSignatureAgent",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "auth",
      "description": "Invoke a native authentication/signature agent installed on the device — the general category for a locally-installed native application holding a user credential (for example, a certificate-based electronic-signature application) that per…"
    },
    {
      "id": "jsonExport",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "media",
      "description": "Export data as JSON file download"
    },
    {
      "id": "loadDatasource",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "data",
      "description": "Load datasource from registry"
    },
    {
      "id": "log",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "utility",
      "description": "Log message to console"
    },
    {
      "id": "mediaCapture",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "media",
      "description": "Capture photo or video"
    },
    {
      "id": "mediaControl",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "media",
      "description": "Control a host media element: play, pause, seek, volume, fullscreen."
    },
    {
      "id": "navigate",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "navigation",
      "description": "Navigate to a route"
    },
    {
      "id": "notification",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "ui",
      "description": "System notification"
    },
    {
      "id": "openAuthSession",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "auth",
      "description": "Open an OAuth/SSO auth session in an in-app browser. On RN uses expo-web-browser openAuthSessionAsync. On web falls back to window.open popup."
    },
    {
      "id": "openModal",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "ui",
      "description": "Open a host-registered modal by id."
    },
    {
      "id": "openNativeFilePicker",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "system",
      "description": "Runtime alias for pickFiles used by native flows."
    },
    {
      "id": "payment",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "crypto",
      "description": "Process payment"
    },
    {
      "id": "pickFiles",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "system",
      "description": "Open a file picker and write selected file metadata to state."
    },
    {
      "id": "printAction",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "utility",
      "description": "Print current page"
    },
    {
      "id": "queueAction",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "utility",
      "description": "Queue an action for deferred execution (alias for queue)"
    },
    {
      "id": "realtimeSync",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "network",
      "description": "Subscribe to server-sent events. Use supabaseRealtime instead."
    },
    {
      "id": "removeWhere",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "state",
      "description": "Removes items from an array that match a condition. Selector is `predicate` (an arrow-function string) — NEVER `where`. Dispatched as `actionSetState({ ...params, operation: \"removeWhere\" })` (action-flow-engine.ts:308), which reads `param…"
    },
    {
      "id": "restApi",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "data",
      "description": "Make REST API HTTP request. The response is written to the state path named by `params.resultTarget` — that is the ONE canonical result-key name (action-flow-engine.ts:1977 reads resultTarget ?? target ?? responseKey, plus a legacy resultK…"
    },
    {
      "id": "retryAction",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "utility",
      "description": "Retry an action on failure (alias for retry)"
    },
    {
      "id": "runMotion",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "motion",
      "description": "Run a UI animation and await its completion before the next ActionFlow step"
    },
    {
      "id": "scrollTo",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "ui",
      "description": "Scroll to an element or position"
    },
    {
      "id": "scrollToElement",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "ui",
      "description": "Scroll the viewport to a target element by ID."
    },
    {
      "id": "scrollToPosition",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "navigation",
      "description": "Scroll to a specific x/y coordinate"
    },
    {
      "id": "setState",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "data",
      "description": "Update a state variable. With operation:\"append\"/\"prepend\" adds value to an array target (the runtime-canonical way to add a list item); operation:\"removeWhere\"/\"updateWhere\" select rows with a `predicate` arrow-function string (NEVER a `w…"
    },
    {
      "id": "setTableCell",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "data",
      "description": "Set a single cell value in a table array"
    },
    {
      "id": "setTheme",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "ui",
      "description": "Request a host theme/style scope change."
    },
    {
      "id": "setVariable",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "data",
      "description": "Set a named variable"
    },
    {
      "id": "shareAction",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "media",
      "description": "Share content via system share dialog"
    },
    {
      "id": "showLoading",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "ui",
      "description": "Show/hide loading overlay"
    },
    {
      "id": "showPopup",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "ui",
      "description": "Show popup dialog"
    },
    {
      "id": "showToast",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "ui",
      "description": "Show toast notification"
    },
    {
      "id": "simulateError",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "flow",
      "description": "Throw a simulated error for testing tryCatch"
    },
    {
      "id": "sortByField",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "data",
      "description": "Sort an array from a source state path by an object field and write the sorted result to a target path."
    },
    {
      "id": "stopFlow",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "flow",
      "description": "Stop current flow execution"
    },
    {
      "id": "storage",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "utility",
      "description": "Local storage operations"
    },
    {
      "id": "supabaseAuth",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "auth",
      "description": "Supabase auth operations (signIn/signUp/signOut/etc.)"
    },
    {
      "id": "supabaseQuery",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "data",
      "description": "Query Supabase table"
    },
    {
      "id": "supabaseRealtime",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "realtime",
      "description": "Subscribe to postgres changes, broadcast messages, and presence via Supabase Realtime channels"
    },
    {
      "id": "supabaseRpc",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "data",
      "description": "Call Supabase RPC function"
    },
    {
      "id": "supabaseStorage",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "storage",
      "description": "Supabase storage upload/download/signed URL"
    },
    {
      "id": "throttleAction",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "utility",
      "description": "Throttle action execution (alias for throttle)"
    },
    {
      "id": "transactionAction",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "data",
      "description": "Execute steps as atomic transaction"
    },
    {
      "id": "updateWhere",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "state",
      "description": "Updates items in an array that match a condition. Selector is `predicate` (an arrow-function string) and the field dictionary is `updates` — NEVER `where`, and NOT `update` on this standalone action. The runtime dispatches it as `actionSet…"
    },
    {
      "id": "uploadFiles",
      "kind": "action",
      "scope": "platform",
      "source": "packages/cogo-action-registry/src/generated/action-capability-registry.v1.json",
      "category": "system",
      "description": "Upload selected files through a platform or datasource adapter."
    },
    {
      "id": "upsertWhere",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "state",
      "description": "Updates matching item or inserts new one if no match found"
    },
    {
      "id": "validate",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "form",
      "description": "Validate form inputs before submission"
    },
    {
      "id": "wallet.create",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "wallet",
      "description": "Create new wallet"
    },
    {
      "id": "wallet.estimateFee",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "wallet",
      "description": "Estimate transaction fee"
    },
    {
      "id": "wallet.getBalance",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "wallet",
      "description": "Get wallet balance"
    },
    {
      "id": "wallet.getTxHistory",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "wallet",
      "description": "Get transaction history"
    },
    {
      "id": "wallet.getTxStatus",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "wallet",
      "description": "Get transaction status"
    },
    {
      "id": "wallet.list",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "wallet",
      "description": "List user wallets"
    },
    {
      "id": "wallet.send",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "wallet",
      "description": "Send transaction"
    },
    {
      "id": "wallet.syncBalance",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "wallet",
      "description": "Sync wallet balance from chain"
    },
    {
      "id": "web3",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "crypto",
      "description": "Web3 blockchain interaction"
    },
    {
      "id": "websocket",
      "kind": "action",
      "scope": "platform",
      "source": "ontology/action-types.json",
      "category": "data",
      "description": "WebSocket connection management"
    },
    {
      "id": "bakery_storefront_template",
      "kind": "application-term",
      "scope": "app:bakery-storefront",
      "source": "ontology/applications/bakery-storefront-template.application-terminology.json",
      "description": "The registered bakery-storefront template (TEMPLATE_REGISTRY entry 'bakery-storefront') — a storefront selling baked goods.",
      "terms": [
        "bakery",
        "베이커리",
        "빵집",
        "제과점"
      ],
      "ontologyRefs": [
        "template:bakery-storefront"
      ]
    },
    {
      "id": "fixture_snack_shelf",
      "kind": "application-term",
      "scope": "app:fixture-task3-demo",
      "source": "ontology/applications/fixture-demo-app.application-terminology.json",
      "description": "FIXTURE term — a shelf view in a fictional demo app. Proves an application can define its own surface vocabulary distinct from platform terminology.",
      "terms": [
        "snack shelf",
        "간식진열대"
      ]
    },
    {
      "id": "fixture_snack_shelf_restock",
      "kind": "application-term",
      "scope": "app:fixture-task3-demo",
      "source": "ontology/applications/fixture-demo-app.application-terminology.json",
      "description": "FIXTURE term — flags the fixture Snack Shelf as needing restock. Deliberately unrelated to any real coogo action.",
      "terms": [
        "restock",
        "재입고"
      ]
    },
    {
      "id": "wonbanking_account",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "A bank account (checking, savings, etc.) that balances, transfers, and statements attach to.",
      "terms": [
        "account",
        "계좌"
      ]
    },
    {
      "id": "wonbanking_account_name",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "The human-readable label of an account (자유입출금, 정기예금, …) as distinct from its number. Includes the synthetic contract field code acctNm.",
      "terms": [
        "account name",
        "acctNm",
        "계좌명"
      ]
    },
    {
      "id": "wonbanking_account_number",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "The identifying number of a bank account — the primary key most account screens key their rows on. Includes the synthetic 한별은행 contract field code acctNo.",
      "terms": [
        "account number",
        "acctNo",
        "계좌번호"
      ],
      "alignment": {
        "decision": "teach",
        "canonicalSymbol": "acctNo",
        "priorSymbols": [
          "acnoInput"
        ],
        "rationale": "terminology-alignment-pilot task 4 (2026-08-14): on the AS-IS login screen's account-number-confirmation step (the acno_form tab), the withheld-terminology probe's connected model reached for a screen-local `acnoInput` name for this field. This glossary already canonicalizes the account-number concept as `acctNo` (see this term's own `terms`); the model should reuse that symbol rather than mint a new one."
      }
    },
    {
      "id": "wonbanking_auth_code",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "The SMS/phone verification code entered on this screen's phone-verification tab after a code is requested. Added by the terminology-alignment pilot (task 4, 2026-08-14) from the AS-IS login page itself, not the curated domain glossary sour…",
      "terms": [
        "auth code",
        "authCode",
        "인증번호"
      ],
      "alignment": {
        "decision": "teach",
        "canonicalSymbol": "authCode",
        "priorSymbols": [
          "authCodeInput",
          "authCodeValid"
        ],
        "rationale": "terminology-alignment-pilot task 4 (2026-08-14): the withheld-terminology probe's connected model splits this field into a raw-value name (`authCodeInput`) and a separately derived validity boolean (`authCodeValid`). The AS-IS page names the field itself directly (see this term's provenance.locator for the citation), so the domain's canonical symbol is `authCode` for both the value and its validity check."
      }
    },
    {
      "id": "wonbanking_balance",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "The current amount of money held in an account. Includes the synthetic contract field code balAmt.",
      "terms": [
        "balAmt",
        "balance",
        "잔액"
      ]
    },
    {
      "id": "wonbanking_branch",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "A physical bank branch location; 영업점 and 지점 are the two Korean surface forms used for the same concept.",
      "terms": [
        "bank-location",
        "branch",
        "영업점",
        "지점"
      ]
    },
    {
      "id": "wonbanking_browser_certificate",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "One of three certificate-based login methods this screen offers as separate tabs: a certificate already stored in the user's browser, chosen from a list before its password is requested (see wonbanking_cert_password for that password field…",
      "terms": [
        "browser certificate",
        "certLgn",
        "브라우저인증",
        "브라우저인증서"
      ]
    },
    {
      "id": "wonbanking_cert_password",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "The password for a selected browser certificate, entered on this screen's browser-certificate login tab. Added by the terminology-alignment pilot (task 4, 2026-08-14) from the AS-IS login page itself, not the curated domain glossary source…",
      "terms": [
        "certPassword",
        "certificate password",
        "인증서 비밀번호"
      ],
      "alignment": {
        "decision": "teach",
        "canonicalSymbol": "certPassword",
        "priorSymbols": [
          "certPwInput"
        ],
        "rationale": "terminology-alignment-pilot task 4 (2026-08-14): the withheld-terminology probe's connected model derives a screen-local `certPwInput` name for this field. The AS-IS page names this field directly (see this term's provenance.locator for the citation), so the domain's canonical symbol is `certPassword`."
      }
    },
    {
      "id": "wonbanking_channel_code",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "Message-spec transport metadata recording which channel originated a transaction; specs routinely rule it internal-only, never rendered. Includes the synthetic contract field code chnlCd.",
      "terms": [
        "channel code",
        "chnlCd",
        "채널코드"
      ]
    },
    {
      "id": "wonbanking_closed_account",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "An account that has been terminated; whether closed accounts appear in a list ('해지계좌 포함') is a screen-level decision specs either state or leave as a trap.",
      "terms": [
        "closed account",
        "해지계좌"
      ]
    },
    {
      "id": "wonbanking_currency_exchange",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "Converting one currency into another at a bank's posted rate.",
      "terms": [
        "currency-exchange",
        "forex",
        "환전"
      ]
    },
    {
      "id": "wonbanking_financial_certificate",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "One of three certificate-based login methods this screen offers as separate tabs: the cross-institution financial-sector authentication certificate, distinct from Woori's own certificate and from a general browser-stored certificate. The s…",
      "terms": [
        "finCertLgn",
        "financial certificate",
        "금융인증서"
      ]
    },
    {
      "id": "wonbanking_loan",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "A bank-issued loan or credit facility extended to a customer.",
      "terms": [
        "loan",
        "대출"
      ]
    },
    {
      "id": "wonbanking_login_id",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "The username/ID field on this screen's ID+password login tab, distinct from an account number or a resident registration number. Added by the terminology-alignment pilot (task 4, 2026-08-14) from the AS-IS login page itself, not the curate…",
      "terms": [
        "login id",
        "userId",
        "아이디"
      ],
      "alignment": {
        "decision": "teach",
        "canonicalSymbol": "userId",
        "priorSymbols": [
          "idValid"
        ],
        "rationale": "terminology-alignment-pilot task 4 (2026-08-14): the withheld-terminology probe's connected model derives an ad hoc boolean `idValid` for this field instead of naming the field itself. The AS-IS page names this field directly (see this term's provenance.locator for the citation), so the domain's canonical symbol is `userId` — a validity check should read that field rather than invent a disconnected boolean name."
      }
    },
    {
      "id": "wonbanking_login_password",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "The password field on this screen's ID+password login tab. Added by the terminology-alignment pilot (task 4, 2026-08-14) from the AS-IS login page itself, not the curated domain glossary source — see provenance.",
      "terms": [
        "login password",
        "password",
        "비밀번호"
      ],
      "alignment": {
        "decision": "teach",
        "canonicalSymbol": "password",
        "priorSymbols": [
          "pwValid"
        ],
        "rationale": "terminology-alignment-pilot task 4 (2026-08-14): the withheld-terminology probe's connected model derives an ad hoc boolean `pwValid` for this field instead of naming the field itself. The AS-IS page names this field directly (see this term's provenance.locator for the citation), so the domain's canonical symbol is `password`."
      }
    },
    {
      "id": "wonbanking_phone_number",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "The mobile phone number field on this screen's phone-verification tab. Added by the terminology-alignment pilot (task 4, 2026-08-14) from the AS-IS login page itself, not the curated domain glossary source — see provenance.",
      "terms": [
        "phone number",
        "phoneNumber",
        "휴대폰 번호",
        "휴대폰번호"
      ],
      "alignment": {
        "decision": "teach",
        "canonicalSymbol": "phoneNumber",
        "priorSymbols": [
          "hpNoValid"
        ],
        "rationale": "terminology-alignment-pilot task 4 (2026-08-14): the withheld-terminology probe's connected model derives an ad hoc boolean `hpNoValid` for this field instead of naming the field itself. The AS-IS page names this field directly (see this term's provenance.locator for the citation), so the domain's canonical symbol is `phoneNumber`."
      }
    },
    {
      "id": "wonbanking_primary_account",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "The account designated as the customer's representative/default account, often visually emphasized in account lists.",
      "terms": [
        "primary account",
        "representative account",
        "대표계좌"
      ]
    },
    {
      "id": "wonbanking_real_name_inquiry",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "The real-name verification lookup against another bank's account (타행 실명조회) — a distinct interaction with an explicit failure path.",
      "terms": [
        "real-name inquiry",
        "real-name verification",
        "실명조회"
      ]
    },
    {
      "id": "wonbanking_remittance",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "Sending money to another party, typically outside the sender's own accounts.",
      "terms": [
        "remittance",
        "송금"
      ]
    },
    {
      "id": "wonbanking_resident_number",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "The Korean resident registration number, split across two input fields on this screen's phone-verification tab (front six digits + back first digit). Added by the terminology-alignment pilot (task 4, 2026-08-14) from the AS-IS login page i…",
      "terms": [
        "resident registration number",
        "residentNumber",
        "주민등록번호"
      ],
      "alignment": {
        "decision": "teach",
        "canonicalSymbol": "residentNumber",
        "priorSymbols": [
          "jumin1Valid",
          "jumin2Valid"
        ],
        "rationale": "terminology-alignment-pilot task 4 (2026-08-14): the withheld-terminology probe's connected model derives two separate per-segment booleans (`jumin1Valid`, `jumin2Valid`) instead of naming the underlying field — one per AS-IS input segment (see this term's provenance.locator for the citation). The AS-IS page's own concept is the single resident registration number split across the two inputs; the domain's canonical symbol for the joined value is `residentNumber`."
      }
    },
    {
      "id": "wonbanking_settlement",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "Back-office settlement and reconciliation of transactions against ledger balances.",
      "terms": [
        "reconciliation",
        "settlement",
        "정산"
      ]
    },
    {
      "id": "wonbanking_transaction_history",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "The list of transactions recorded against an account — the paging list screen every banking app has.",
      "terms": [
        "transaction history",
        "transactions",
        "거래내역"
      ]
    },
    {
      "id": "wonbanking_transaction_sequence",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "The per-transaction sequence number a banking message spec assigns for reconciliation; message plumbing usually ruled internal-only. Includes the synthetic contract field code trxSeq.",
      "terms": [
        "transaction sequence number",
        "trxSeq",
        "거래일련번호"
      ]
    },
    {
      "id": "wonbanking_transfer",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "Moving funds between accounts (most commonly the user's own, or within the same bank).",
      "terms": [
        "remittance",
        "transfer",
        "이체"
      ]
    },
    {
      "id": "wonbanking_won_certificate",
      "kind": "application-term",
      "scope": "app:wonbanking",
      "source": "ontology/applications/wonbanking-domain-glossary.application-terminology.json",
      "description": "One of three certificate-based login methods this screen offers as separate tabs: Woori's own proprietary certificate product. It is also the tab shown by default. The same tab links to issuing this certificate, alongside the login option.…",
      "terms": [
        "WON certificate",
        "wonCertLgn",
        "우리WON인증",
        "우리WON인증서"
      ]
    },
    {
      "id": "accordion",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Expandable/collapsible content sections — open state, keyboard nav built-in",
      "terms": [
        "collapsible",
        "faq"
      ]
    },
    {
      "id": "accordion-content",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Collapsible content body of an accordion-item — shown when trigger is active",
      "terms": [
        "content",
        "panel"
      ]
    },
    {
      "id": "accordion-item",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "interactive",
      "description": "Single accordion panel",
      "terms": [
        "panel"
      ]
    },
    {
      "id": "accordion-trigger",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "interactive",
      "description": "Clickable trigger header of an accordion-item — toggles open/closed state",
      "terms": [
        "panel",
        "trigger"
      ]
    },
    {
      "id": "add-to-cart-button",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-front-office",
      "description": "Primary CTA on ProductDetail that triggers AddToCartAction (restApi to ACP + setState cart_session). cofo:ProductDetail required section.",
      "terms": [
        "cart",
        "cofo",
        "cta",
        "product-detail"
      ]
    },
    {
      "id": "alert",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Notification banner for messages",
      "terms": [
        "notification",
        "warning"
      ]
    },
    {
      "id": "alert-description",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Renderer-aligned alert-description element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "alert",
        "description",
        "feedback"
      ]
    },
    {
      "id": "alert-dialog",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Confirmation dialog — confirm/cancel, focus trap, escape key built-in",
      "terms": [
        "confirm",
        "prompt"
      ]
    },
    {
      "id": "alert-dialog-action",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Renderer-aligned alert-dialog-action element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "action",
        "alert",
        "dialog",
        "feedback"
      ]
    },
    {
      "id": "alert-dialog-cancel",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Renderer-aligned alert-dialog-cancel element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "alert",
        "cancel",
        "dialog",
        "feedback"
      ]
    },
    {
      "id": "alert-dialog-content",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Renderer-aligned alert-dialog-content element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "alert",
        "content",
        "dialog",
        "feedback"
      ]
    },
    {
      "id": "alert-dialog-description",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Renderer-aligned alert-dialog-description element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "alert",
        "description",
        "dialog",
        "feedback"
      ]
    },
    {
      "id": "alert-dialog-footer",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Renderer-aligned alert-dialog-footer element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "alert",
        "dialog",
        "feedback",
        "footer"
      ]
    },
    {
      "id": "alert-dialog-header",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Renderer-aligned alert-dialog-header element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "alert",
        "dialog",
        "feedback",
        "header"
      ]
    },
    {
      "id": "alert-dialog-title",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Renderer-aligned alert-dialog-title element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "alert",
        "dialog",
        "feedback",
        "title"
      ]
    },
    {
      "id": "alert-dialog-trigger",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Renderer-aligned alert-dialog-trigger element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "alert",
        "dialog",
        "feedback",
        "trigger"
      ]
    },
    {
      "id": "alert-title",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Renderer-aligned alert-title element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "alert",
        "feedback",
        "title"
      ]
    },
    {
      "id": "article",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Self-contained content block",
      "terms": [
        "entry",
        "post"
      ]
    },
    {
      "id": "aside",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Sidebar or complementary content",
      "terms": [
        "sidebar"
      ]
    },
    {
      "id": "aspect-ratio",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Maintains standard aspect ratio for its child component. shadcn AspectRatio equivalent.",
      "terms": [
        "layout",
        "ratio"
      ]
    },
    {
      "id": "avatar",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "User profile image or initials",
      "terms": [
        "profile",
        "user"
      ]
    },
    {
      "id": "avatar-group",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Renderer-aligned avatar-group element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "avatar",
        "group",
        "layout"
      ]
    },
    {
      "id": "badge",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Small status indicator or label tag",
      "terms": [
        "chip",
        "label",
        "status",
        "tag"
      ]
    },
    {
      "id": "block-ref",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "composition",
      "description": "Reference to another block (composable blocks)",
      "terms": [
        "include",
        "reference"
      ]
    },
    {
      "id": "brand-logo",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-generic",
      "description": "Brand identity element. cofog:FooterPattern required section.",
      "terms": [
        "brand",
        "cofog",
        "footer"
      ]
    },
    {
      "id": "breadcrumb",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Breadcrumb navigation trail — separators, truncation built-in",
      "terms": [
        "path",
        "trail"
      ]
    },
    {
      "id": "button",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "basic",
      "description": "Interactive button with variant, size, and event handler",
      "terms": [
        "action",
        "click",
        "cta",
        "submit"
      ]
    },
    {
      "id": "button-group",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "action",
      "description": "Renderer-aligned button-group element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "action",
        "button",
        "group"
      ]
    },
    {
      "id": "button-group-separator",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "action",
      "description": "Renderer-aligned button-group-separator element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "action",
        "button",
        "group",
        "separator"
      ]
    },
    {
      "id": "button-group-text",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "action",
      "description": "Renderer-aligned button-group-text element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "action",
        "button",
        "group",
        "text"
      ]
    },
    {
      "id": "calendar",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Full calendar display — month navigation, date selection built-in",
      "terms": [
        "schedule"
      ]
    },
    {
      "id": "card",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Elevated surface container with rounded corners",
      "terms": [
        "panel",
        "surface",
        "tile"
      ]
    },
    {
      "id": "card-action",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Card action button area — top-right actions",
      "terms": [
        "card-part"
      ]
    },
    {
      "id": "card-content",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-generic",
      "description": "Body content of a Card. cofog:CardPattern required section.",
      "terms": [
        "body",
        "card",
        "cofog"
      ]
    },
    {
      "id": "card-description",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "typography",
      "description": "Card description text — muted paragraph",
      "terms": [
        "card-part"
      ]
    },
    {
      "id": "card-footer",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Card footer section — actions, links",
      "terms": [
        "card-part"
      ]
    },
    {
      "id": "card-header",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Card header section — title, description, actions",
      "terms": [
        "card-part"
      ]
    },
    {
      "id": "card-title",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-generic",
      "description": "Primary heading of a Card. cofog:CardPattern required section.",
      "terms": [
        "card",
        "cofog",
        "title"
      ]
    },
    {
      "id": "carousel",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Swipeable horizontal gallery — slide nav, autoplay, indicators built-in",
      "terms": [
        "gallery",
        "slider"
      ]
    },
    {
      "id": "cart-line",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-front-office",
      "description": "Single cart line item. kind ∈ cofo:CartLineKind (product / shipping / discount / tax). quantity is a positive integer ≥ 1.",
      "terms": [
        "cart",
        "cofo",
        "item",
        "line"
      ]
    },
    {
      "id": "cart-lines",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-front-office",
      "description": "Cart line-item list. Iterates appData.cart.items; each line shows qty controls + remove + per-line subtotal. cofo:Cart required section (cofo:CartPatternShape).",
      "terms": [
        "cart",
        "cofo",
        "lines",
        "list"
      ]
    },
    {
      "id": "chart",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Data visualization chart — responsive, legend, tooltip built-in",
      "terms": [
        "graph",
        "visualization"
      ]
    },
    {
      "id": "checkbox",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Boolean toggle checkbox",
      "terms": [
        "boolean",
        "check",
        "toggle"
      ]
    },
    {
      "id": "checkout-cta",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-front-office",
      "description": "Cart→Checkout transition CTA region. Wraps the primary Proceed-to-Checkout action; disabled when cart empty allowed. cofo:Cart required section (cofo:CartPatternShape).",
      "terms": [
        "cart",
        "checkout",
        "cofo",
        "cta"
      ]
    },
    {
      "id": "checkout-step",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-front-office",
      "description": "Single step entry inside a step-indicator. The `step` property MUST be one of cofo:CheckoutStep closed-6 enum values (cart, address, fulfillment, payment, review, confirmation).",
      "terms": [
        "checkout",
        "cofo",
        "step"
      ]
    },
    {
      "id": "chip-input",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Tag/chip input with add/remove",
      "terms": [
        "chips",
        "tags"
      ]
    },
    {
      "id": "collapsible",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Collapsible content section — open/close toggle built-in",
      "terms": [
        "expandable",
        "toggle"
      ]
    },
    {
      "id": "color-picker",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Color selection control",
      "terms": [
        "color",
        "palette"
      ]
    },
    {
      "id": "combobox",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Searchable dropdown with autocomplete — search, keyboard nav built-in",
      "terms": [
        "autocomplete",
        "search-select"
      ]
    },
    {
      "id": "command",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Command palette / search dialog — search, keyboard nav, grouping built-in",
      "terms": [
        "palette",
        "search"
      ]
    },
    {
      "id": "confirmation-display",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-front-office",
      "description": "Order confirmation display shown after a successful placeOrder. Includes order id, success messaging, and next-step CTAs. cofo:Checkout required section (cofo:CheckoutPatternShape).",
      "terms": [
        "checkout",
        "cofo",
        "confirmation"
      ]
    },
    {
      "id": "container",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Generic wrapper element with layout, padding, and styling",
      "terms": [
        "box",
        "div",
        "frame",
        "wrapper"
      ]
    },
    {
      "id": "context-menu",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Context menu — right-click triggered, keyboard nav, sub-menus, a11y built-in",
      "terms": [
        "menu"
      ]
    },
    {
      "id": "context-menu-content",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Renderer-aligned context-menu-content element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "content",
        "context-menu",
        "menu",
        "navigation"
      ]
    },
    {
      "id": "context-menu-group",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Renderer-aligned context-menu-group element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "context-menu",
        "group",
        "menu",
        "navigation"
      ]
    },
    {
      "id": "context-menu-item",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Renderer-aligned context-menu-item element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "context-menu",
        "item",
        "menu",
        "navigation"
      ]
    },
    {
      "id": "context-menu-label",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Renderer-aligned context-menu-label element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "context-menu",
        "label",
        "menu",
        "navigation"
      ]
    },
    {
      "id": "context-menu-separator",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Renderer-aligned context-menu-separator element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "context-menu",
        "menu",
        "navigation",
        "separator"
      ]
    },
    {
      "id": "context-menu-trigger",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Renderer-aligned context-menu-trigger element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "context-menu",
        "menu",
        "navigation",
        "trigger"
      ]
    },
    {
      "id": "copyright",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-generic",
      "description": "Legal copyright notice. cofog:FooterPattern required section.",
      "terms": [
        "cofog",
        "footer"
      ]
    },
    {
      "id": "cta-button",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-generic",
      "description": "Call-to-action button. Position ∈ cofog:CtaPosition (top / bottom / center / inline).",
      "terms": [
        "button",
        "cofog",
        "cta"
      ]
    },
    {
      "id": "data_table",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "table",
      "description": "Data table with columns, pagination, and row actions (snake_case alias)",
      "terms": [
        "grid",
        "list",
        "spreadsheet",
        "table"
      ]
    },
    {
      "id": "data-table",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Data table with sorting, pagination, filtering built-in",
      "terms": [
        "grid",
        "list",
        "spreadsheet"
      ]
    },
    {
      "id": "date-picker",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Calendar-based date selection — popup, month nav, formatting built-in",
      "terms": [
        "calendar",
        "date"
      ]
    },
    {
      "id": "dialog",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Modal dialog overlay — open/close, backdrop, focus trap built-in",
      "terms": [
        "modal",
        "popup"
      ]
    },
    {
      "id": "dialog-content",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "overlay",
      "description": "Renderer-aligned dialog-content element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned — dialog-renderer.tsx type-matches a `dialog-content` child by name (`allChildren.find(…",
      "terms": [
        "content",
        "dialog",
        "overlay"
      ]
    },
    {
      "id": "dialog-trigger",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "overlay",
      "description": "Renderer-aligned dialog-trigger element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned — dialog-renderer.tsx type-matches a `dialog-trigger` child by name (`allChildren.find(…",
      "terms": [
        "dialog",
        "overlay",
        "trigger"
      ]
    },
    {
      "id": "divider",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Horizontal/vertical divider line",
      "terms": [
        "hr",
        "separator"
      ]
    },
    {
      "id": "drawer",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Slide-in drawer panel — open/close, snap points, swipe built-in",
      "terms": [
        "side-panel"
      ]
    },
    {
      "id": "dropdown-menu",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Dropdown menu — keyboard nav, sub-menus, a11y built-in",
      "terms": [
        "context-menu",
        "menu"
      ]
    },
    {
      "id": "dropdown-menu-content",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Renderer-aligned dropdown-menu-content element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "content",
        "dropdown",
        "menu",
        "navigation"
      ]
    },
    {
      "id": "dropdown-menu-group",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Renderer-aligned dropdown-menu-group element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "dropdown",
        "group",
        "menu",
        "navigation"
      ]
    },
    {
      "id": "dropdown-menu-item",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Renderer-aligned dropdown-menu-item element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "dropdown",
        "item",
        "menu",
        "navigation"
      ]
    },
    {
      "id": "dropdown-menu-label",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Renderer-aligned dropdown-menu-label element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "dropdown",
        "label",
        "menu",
        "navigation"
      ]
    },
    {
      "id": "dropdown-menu-separator",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Renderer-aligned dropdown-menu-separator element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "dropdown",
        "menu",
        "navigation",
        "separator"
      ]
    },
    {
      "id": "dropdown-menu-trigger",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Renderer-aligned dropdown-menu-trigger element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "dropdown",
        "menu",
        "navigation",
        "trigger"
      ]
    },
    {
      "id": "empty",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Empty-state container — shown when a list/grid/feed has no items to display",
      "terms": [
        "fallback",
        "no-data",
        "placeholder"
      ]
    },
    {
      "id": "empty-action",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "interactive",
      "description": "Call-to-action region inside an empty-state (typically contains buttons/links)",
      "terms": [
        "cta",
        "empty"
      ]
    },
    {
      "id": "empty-content",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Primary content region of an empty-state (between header and action)",
      "terms": [
        "empty"
      ]
    },
    {
      "id": "empty-description",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "text",
      "description": "Secondary description text for an empty-state",
      "terms": [
        "empty",
        "prose"
      ]
    },
    {
      "id": "empty-header",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Header region within an empty-state (icon + title)",
      "terms": [
        "empty"
      ]
    },
    {
      "id": "empty-icon",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "display",
      "description": "Decorative icon/illustration for an empty-state",
      "terms": [
        "empty",
        "illustration"
      ]
    },
    {
      "id": "empty-media",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "display",
      "description": "Media slot (image/video/animation) inside an empty-state",
      "terms": [
        "empty",
        "media"
      ]
    },
    {
      "id": "empty-title",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "text",
      "description": "Title text for an empty-state",
      "terms": [
        "empty",
        "heading"
      ]
    },
    {
      "id": "field",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Single form field wrapper — contains label + control + optional description",
      "terms": [
        "form",
        "shadcn"
      ]
    },
    {
      "id": "field-content",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Content region within a field (contains the control — input/select/etc.)",
      "terms": [
        "form"
      ]
    },
    {
      "id": "field-description",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Descriptive / helper text for a form field",
      "terms": [
        "form",
        "helper-text"
      ]
    },
    {
      "id": "field-group",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Group of related form fields (semantic grouping; renders as <div> or <section>)",
      "terms": [
        "fieldset",
        "form",
        "group"
      ]
    },
    {
      "id": "field-label",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Label for a form field — shadcn field-label variant",
      "terms": [
        "form",
        "label"
      ]
    },
    {
      "id": "field-legend",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Title for a field-set — HTML <legend>-equivalent",
      "terms": [
        "form",
        "heading"
      ]
    },
    {
      "id": "field-set",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "HTML <fieldset>-equivalent — grouping of related fields with a shared legend",
      "terms": [
        "fieldset",
        "form",
        "html"
      ]
    },
    {
      "id": "footer",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Page or section footer",
      "terms": [
        "bottom"
      ]
    },
    {
      "id": "form",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Form container — validation, error display, submit handling built-in",
      "terms": [
        "fieldset",
        "form-group"
      ]
    },
    {
      "id": "header",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Page or section header",
      "terms": [
        "top"
      ]
    },
    {
      "id": "heading",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "basic",
      "description": "Renderer-aligned heading element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "basic"
      ]
    },
    {
      "id": "headline",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-generic",
      "description": "Primary heading — main message of a Hero or other section.",
      "terms": [
        "cofog",
        "heading",
        "hero"
      ]
    },
    {
      "id": "hero-banner",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-generic",
      "description": "Hero banner — above-the-fold container with image, video, or text background. Variant ∈ cofog:HeroVariant. cofog:HeroPattern required section.",
      "terms": [
        "banner",
        "cofog",
        "hero"
      ]
    },
    {
      "id": "hover-card",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Card that appears on hover — hover delay, positioning built-in",
      "terms": [
        "preview"
      ]
    },
    {
      "id": "icon",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "basic",
      "description": "Renders a Lucide icon by name",
      "terms": [
        "glyph",
        "lucide",
        "symbol"
      ]
    },
    {
      "id": "iframe",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "basic",
      "description": "Embedded iframe preview or external content surface",
      "terms": [
        "embed",
        "preview",
        "web"
      ]
    },
    {
      "id": "image",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "basic",
      "description": "Displays an image from URL or asset",
      "terms": [
        "media",
        "photo",
        "picture"
      ]
    },
    {
      "id": "image-gallery",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-front-office",
      "description": "Image gallery for product detail — main image + thumbnail strip with select/zoom. cofo:ProductDetail required section.",
      "terms": [
        "cofo",
        "gallery",
        "image",
        "product-detail"
      ]
    },
    {
      "id": "input",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Single-line text input field",
      "terms": [
        "form-control",
        "textfield"
      ]
    },
    {
      "id": "input-group",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Horizontal group of input + addons (prefix/suffix text or icon)",
      "terms": [
        "form",
        "group",
        "input"
      ]
    },
    {
      "id": "input-group-addon",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Addon element inside input-group (prefix/suffix; icon or short text)",
      "terms": [
        "addon",
        "form",
        "input"
      ]
    },
    {
      "id": "input-otp",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "One-time password input",
      "terms": [
        "otp",
        "verification"
      ]
    },
    {
      "id": "island",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "integration",
      "description": "Renderer-aligned island element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "integration"
      ]
    },
    {
      "id": "item",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "collection",
      "description": "Renderer-aligned item element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "collection"
      ]
    },
    {
      "id": "item-actions",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "collection",
      "description": "Renderer-aligned item-actions element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "actions",
        "collection",
        "item"
      ]
    },
    {
      "id": "item-content",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "collection",
      "description": "Renderer-aligned item-content element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "collection",
        "content",
        "item"
      ]
    },
    {
      "id": "item-description",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "collection",
      "description": "Renderer-aligned item-description element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "collection",
        "description",
        "item"
      ]
    },
    {
      "id": "item-footer",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "collection",
      "description": "Renderer-aligned item-footer element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "collection",
        "footer",
        "item"
      ]
    },
    {
      "id": "item-group",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "collection",
      "description": "Renderer-aligned item-group element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "collection",
        "group",
        "item"
      ]
    },
    {
      "id": "item-header",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "collection",
      "description": "Renderer-aligned item-header element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "collection",
        "header",
        "item"
      ]
    },
    {
      "id": "item-media",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "collection",
      "description": "Renderer-aligned item-media element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "collection",
        "item",
        "media"
      ]
    },
    {
      "id": "item-separator",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "collection",
      "description": "Renderer-aligned item-separator element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "collection",
        "item",
        "separator"
      ]
    },
    {
      "id": "item-title",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "collection",
      "description": "Renderer-aligned item-title element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "collection",
        "item",
        "title"
      ]
    },
    {
      "id": "kbd",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "basic",
      "description": "Renderer-aligned kbd element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "basic"
      ]
    },
    {
      "id": "label",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Label element for form fields",
      "terms": [
        "field-label"
      ]
    },
    {
      "id": "link",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "interactive",
      "description": "Tappable hyperlink or navigation trigger",
      "terms": [
        "anchor",
        "href",
        "url"
      ]
    },
    {
      "id": "link-columns",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-generic",
      "description": "Multi-column grouped link list in a Footer.",
      "terms": [
        "cofog",
        "footer",
        "links"
      ]
    },
    {
      "id": "list",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Scrollable list container",
      "terms": [
        "feed",
        "items"
      ]
    },
    {
      "id": "list_view",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Renderer alias for source-projected list views; maps to the list renderer while preserving source type evidence.",
      "terms": [
        "collection",
        "list",
        "source-alias"
      ]
    },
    {
      "id": "loader",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Renderer-aligned loader element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "feedback"
      ]
    },
    {
      "id": "logo",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-generic",
      "description": "Brand mark within Navigation. cofog:NavigationPattern required section.",
      "terms": [
        "brand",
        "cofog",
        "navigation"
      ]
    },
    {
      "id": "lottie",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "media",
      "description": "Renderer-aligned lottie element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "media"
      ]
    },
    {
      "id": "main",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Main content area",
      "terms": [
        "content"
      ]
    },
    {
      "id": "map",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Static map renderer with location markers for geospatial application surfaces.",
      "terms": [
        "geospatial",
        "location"
      ]
    },
    {
      "id": "menu-item",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-generic",
      "description": "Individual menu link with label + href (both required per cofog:MenuItemShape).",
      "terms": [
        "cofog",
        "link",
        "navigation"
      ]
    },
    {
      "id": "menu-list",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-generic",
      "description": "List of MenuItems for Navigation. cofog:NavigationPattern required section.",
      "terms": [
        "cofog",
        "menu",
        "navigation"
      ]
    },
    {
      "id": "menubar",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Horizontal menu bar",
      "terms": [
        "menu"
      ]
    },
    {
      "id": "modal",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "overlay",
      "description": "Modal overlay dialog for focused content or actions",
      "terms": [
        "dialog",
        "overlay",
        "popup"
      ]
    },
    {
      "id": "month-picker",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Month and year selection",
      "terms": [
        "month",
        "period"
      ]
    },
    {
      "id": "native-select",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "input",
      "description": "Renderer-aligned native-select element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "input",
        "native",
        "select"
      ]
    },
    {
      "id": "native-select-wrapper",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "input",
      "description": "Renderer-aligned native-select-wrapper element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "input",
        "native",
        "select",
        "wrapper"
      ]
    },
    {
      "id": "nav",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Navigation container",
      "terms": [
        "navigation"
      ]
    },
    {
      "id": "navigation-menu",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Multi-level navigation menu — mega menu, hover triggers, a11y built-in",
      "terms": [
        "mega-menu",
        "nav-bar"
      ]
    },
    {
      "id": "order-review",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-front-office",
      "description": "Final order review section shown at the review step. Renders the line items + totals + shipping/payment summary just before placeOrder. cofo:Checkout required section (cofo:CheckoutPatternShape).",
      "terms": [
        "checkout",
        "cofo",
        "review",
        "summary"
      ]
    },
    {
      "id": "pagination",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Page navigation controls — prev/next, page numbers, ellipsis built-in",
      "terms": [
        "pager"
      ]
    },
    {
      "id": "phone-input",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Phone number input with country code",
      "terms": [
        "phone",
        "tel"
      ]
    },
    {
      "id": "placeholder",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Renderer-aligned placeholder element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "feedback"
      ]
    },
    {
      "id": "popover",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Floating content anchored to trigger — positioning, open/close built-in",
      "terms": [
        "floating",
        "popup"
      ]
    },
    {
      "id": "price-display",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-front-office",
      "description": "Price display with currency and optional strike-through (sale) + discount badge. cofo:ProductDetail required section.",
      "terms": [
        "cofo",
        "currency",
        "price",
        "product-detail"
      ]
    },
    {
      "id": "product-card",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-front-office",
      "description": "Product display card — image + title + price + action. Layout ∈ cofo:ProductCardLayout (vertical / horizontal / compact / featured).",
      "terms": [
        "card",
        "cofo",
        "product-detail",
        "storefront"
      ]
    },
    {
      "id": "progress",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Canonical Luma linear progress track. The unqualified track is 12px high; authored className geometry overrides that preset. Value/max default to 0/100 and children are invalid.",
      "terms": [
        "bar",
        "loading"
      ]
    },
    {
      "id": "progress-indicator",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Leaf progress fill indicator. Width is value/max percent of its containing track; it inherits the track radius unless explicitly authored, and authored children are invalid.",
      "terms": [
        "feedback",
        "indicator",
        "progress"
      ]
    },
    {
      "id": "radial-progress",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Circular progress indicator. Defaults to value 0, max 100, and a platform-neutral 48px size.",
      "terms": [
        "circular",
        "donut"
      ]
    },
    {
      "id": "radio",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Single-selection radio button",
      "terms": [
        "option",
        "radio-button"
      ]
    },
    {
      "id": "radio-group",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "input",
      "description": "Renderer-aligned radio-group element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "group",
        "input",
        "radio"
      ]
    },
    {
      "id": "radio-group-item",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "input",
      "description": "Renderer-aligned radio-group-item element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "group",
        "input",
        "item",
        "radio"
      ]
    },
    {
      "id": "resizable",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "interactive",
      "description": "Resizable panel container",
      "terms": [
        "resize"
      ]
    },
    {
      "id": "ring-progress",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Compact circular progress indicator. Defaults to value 0, max 100, and a platform-neutral 16px size.",
      "terms": [
        "feedback",
        "progress",
        "ring"
      ]
    },
    {
      "id": "scroll-area",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Custom styled scroll area. shadcn ScrollArea equivalent.",
      "terms": [
        "layout",
        "scroll",
        "viewport"
      ]
    },
    {
      "id": "section",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Semantic section wrapper",
      "terms": [
        "region"
      ]
    },
    {
      "id": "select",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Dropdown selection from options — open/close, keyboard nav, a11y built-in",
      "terms": [
        "dropdown",
        "picker"
      ]
    },
    {
      "id": "select-content",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "input",
      "description": "Renderer-aligned select-content element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "content",
        "input",
        "select"
      ]
    },
    {
      "id": "select-trigger",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "input",
      "description": "Renderer-aligned select-trigger element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "input",
        "select",
        "trigger"
      ]
    },
    {
      "id": "separator",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Visual separator line",
      "terms": [
        "divider",
        "line"
      ]
    },
    {
      "id": "sheet",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Slide-in panel — open/close, backdrop, slide animation built-in",
      "terms": [
        "panel",
        "slide"
      ]
    },
    {
      "id": "sidebar",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Application sidebar with sections",
      "terms": [
        "side-nav"
      ]
    },
    {
      "id": "sidebar-inset",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Content area inset next to sidebar",
      "terms": [
        "content-area"
      ]
    },
    {
      "id": "sidebar-trigger",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Button to toggle sidebar visibility",
      "terms": [
        "hamburger",
        "toggle"
      ]
    },
    {
      "id": "skeleton",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Loading placeholder skeleton",
      "terms": [
        "loading",
        "placeholder"
      ]
    },
    {
      "id": "slider",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Draggable slider for numeric range",
      "terms": [
        "range",
        "seek"
      ]
    },
    {
      "id": "social-icons",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-generic",
      "description": "Row of social media icon links.",
      "terms": [
        "cofog",
        "footer",
        "social"
      ]
    },
    {
      "id": "sonner",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "A highly customizable notification toast emitter. shadcn Sonner equivalent.",
      "terms": [
        "feedback",
        "notification",
        "toast"
      ]
    },
    {
      "id": "star-rating",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Star-based rating input",
      "terms": [
        "rating",
        "stars"
      ]
    },
    {
      "id": "step-indicator",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-front-office",
      "description": "Checkout step progress indicator. Children are checkout-step nodes ordered as a contiguous subsequence of cofo:CheckoutStep closed-6 enum (cart → address → fulfillment → payment → review → confirmation). cofo:Checkout required section (cof…",
      "terms": [
        "checkout",
        "cofo",
        "progress"
      ]
    },
    {
      "id": "stepper",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Multi-step wizard — step state, prev/next, completion tracking built-in",
      "terms": [
        "steps",
        "wizard"
      ]
    },
    {
      "id": "subheadline",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-generic",
      "description": "Secondary text below the headline. Optional supporting copy.",
      "terms": [
        "cofog",
        "hero",
        "subheading"
      ]
    },
    {
      "id": "switch",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Toggle switch for on/off state",
      "terms": [
        "on-off",
        "toggle"
      ]
    },
    {
      "id": "tab-trigger",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "navigation",
      "description": "Individual tab trigger button",
      "terms": [
        "tab"
      ]
    },
    {
      "id": "table",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "table",
      "description": "Static HTML table",
      "terms": [
        "grid",
        "rows"
      ]
    },
    {
      "id": "table-body",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "data",
      "description": "Renderer-aligned table-body element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "body",
        "data",
        "table"
      ]
    },
    {
      "id": "table-cell",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "data",
      "description": "Renderer-aligned table-cell element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "cell",
        "data",
        "table"
      ]
    },
    {
      "id": "table-footer",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "data",
      "description": "Renderer-aligned table-footer element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "data",
        "footer",
        "table"
      ]
    },
    {
      "id": "table-head",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "data",
      "description": "Renderer-aligned table-head element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "data",
        "head",
        "table"
      ]
    },
    {
      "id": "table-header",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "data",
      "description": "Renderer-aligned table-header element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "data",
        "header",
        "table"
      ]
    },
    {
      "id": "table-row",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "data",
      "description": "Renderer-aligned table-row element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "data",
        "row",
        "table"
      ]
    },
    {
      "id": "tabs",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Tabbed content panels — active state, keyboard nav, a11y built-in",
      "terms": [
        "segmented",
        "tab-bar"
      ]
    },
    {
      "id": "tabs-content",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Content panel shown when corresponding tab trigger is active",
      "terms": [
        "panel",
        "tabs"
      ]
    },
    {
      "id": "tabs-list",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Container for tab triggers within a tabs component",
      "terms": [
        "navigation",
        "tabs"
      ]
    },
    {
      "id": "tabs-trigger",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "interactive",
      "description": "Clickable tab trigger that switches tab content (alias for tab-trigger)",
      "terms": [
        "navigation",
        "tabs",
        "trigger"
      ]
    },
    {
      "id": "text",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "basic",
      "description": "Renders static or dynamic text content",
      "terms": [
        "heading",
        "label",
        "paragraph",
        "typography"
      ]
    },
    {
      "id": "textarea",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Multi-line text input area",
      "terms": [
        "multiline",
        "text-area"
      ]
    },
    {
      "id": "timeline",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "layout",
      "description": "Vertical timeline of events",
      "terms": [
        "events",
        "history"
      ]
    },
    {
      "id": "toast",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "feedback",
      "description": "Temporary notification popup",
      "terms": [
        "notification",
        "snackbar"
      ]
    },
    {
      "id": "toggle",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "form",
      "description": "Toggle button (pressed/unpressed)",
      "terms": [
        "pressed"
      ]
    },
    {
      "id": "toggle-group",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Group of toggle buttons — single/multi select state built-in",
      "terms": [
        "button-group"
      ]
    },
    {
      "id": "toggle-group-item",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "action",
      "description": "Renderer-aligned toggle-group-item element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "action",
        "group",
        "item",
        "toggle"
      ]
    },
    {
      "id": "tooltip",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "overlay",
      "description": "Hover tooltip with informational text",
      "terms": [
        "hint",
        "info"
      ]
    },
    {
      "id": "totals-summary",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "commerce-front-office",
      "description": "Cart/order totals summary — subtotal + tax + shipping + grand total breakdown. cofo:Cart required section (cofo:CartPatternShape).",
      "terms": [
        "cart",
        "cofo",
        "summary",
        "totals"
      ]
    },
    {
      "id": "tree",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "smart",
      "description": "Hierarchical tree view — expand/collapse, selection, keyboard nav built-in",
      "terms": [
        "hierarchy",
        "nested"
      ]
    },
    {
      "id": "video",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "basic",
      "description": "Renders an HTML5 <video>; auto-registers with the host MediaRegistry for the mediaControl action",
      "terms": [
        "media",
        "player"
      ]
    },
    {
      "id": "waveform",
      "kind": "element-type",
      "scope": "platform",
      "source": "ontology/element-types.json",
      "category": "media",
      "description": "Renderer-aligned waveform element. Added from @cogo/react-renderer registry parity so Cogo JSON, ontology, and renderer registration stay aligned.",
      "terms": [
        "media"
      ]
    },
    {
      "id": "actionClick",
      "kind": "event",
      "scope": "platform",
      "source": "ontology/event-types.json",
      "category": "table",
      "description": "Data table row-level action button click (edit, delete, view) inside an 'actions'-type column. Source of truth: cogo-react-renderer/src/renderers/data-table-renderer.tsx:370. Flow reads #{event.row.<field>} to access the full row object, #…"
    },
    {
      "id": "blur",
      "kind": "event",
      "scope": "platform",
      "source": "ontology/event-types.json",
      "category": "form",
      "description": "Input lost focus"
    },
    {
      "id": "cellChange",
      "kind": "event",
      "scope": "platform",
      "source": "ontology/event-types.json",
      "category": "table",
      "description": "Data table editable cell value committed (edit-mode inputs/selects/checkboxes). Source of truth: cogo-react-renderer/src/renderers/data-table-renderer.tsx:134."
    },
    {
      "id": "cellClick",
      "kind": "event",
      "scope": "platform",
      "source": "ontology/event-types.json",
      "category": "table",
      "description": "Data table cell-level button click (type:'button' column). Source of truth: cogo-react-renderer/src/renderers/data-table-renderer.tsx:309."
    },
    {
      "id": "change",
      "kind": "event",
      "scope": "platform",
      "source": "ontology/event-types.json",
      "category": "form",
      "description": "Input, textarea, select value change"
    },
    {
      "id": "close",
      "kind": "event",
      "scope": "platform",
      "source": "ontology/event-types.json",
      "category": "overlay",
      "description": "Dismiss event from dialog/sheet/drawer/popover when user closes via X button, backdrop click, or Escape. Source of truth: cogo-react-renderer/src/renderers/{dialog,sheet,drawer,popover}-renderer.tsx — empty payload object dispatched on clo…"
    },
    {
      "id": "focus",
      "kind": "event",
      "scope": "platform",
      "source": "ontology/event-types.json",
      "category": "form",
      "description": "Input gained focus"
    },
    {
      "id": "keydown",
      "kind": "event",
      "scope": "platform",
      "source": "ontology/event-types.json",
      "category": "keyboard",
      "description": "Key press event. Branch on #{event.key === 'Enter'} / 'Escape' / 'Tab' etc. in the flow — do NOT invent event type names like ':enter' or ':escape'."
    },
    {
      "id": "keyup",
      "kind": "event",
      "scope": "platform",
      "source": "ontology/event-types.json",
      "category": "keyboard",
      "description": "Key release event. Same payload as keydown."
    },
    {
      "id": "rowClick",
      "kind": "event",
      "scope": "platform",
      "source": "ontology/event-types.json",
      "category": "table",
      "description": "Data table row clicked (anywhere outside a button/action column). Source of truth: cogo-react-renderer/src/renderers/data-table-renderer.tsx:126."
    },
    {
      "id": "scroll",
      "kind": "event",
      "scope": "platform",
      "source": "ontology/event-types.json",
      "category": "pointer",
      "description": "Scrollable container scrolled"
    },
    {
      "id": "selectionChange",
      "kind": "event",
      "scope": "platform",
      "source": "ontology/event-types.json",
      "category": "table",
      "description": "Data table row selection change (multi-select checkbox). RESERVED — not yet dispatched by cogo-react-renderer (selection state is currently local to the renderer). Do NOT bind to this event until the renderer emits it; use an explicit per-…"
    },
    {
      "id": "submit",
      "kind": "event",
      "scope": "platform",
      "source": "ontology/event-types.json",
      "category": "form",
      "description": "Form submit (explicit; inputs typically use keydown + Enter branch instead)"
    },
    {
      "id": "tap",
      "kind": "event",
      "scope": "platform",
      "source": "ontology/event-types.json",
      "category": "pointer",
      "description": "Primary click / tap on an element (buttons, links, cards, etc.)"
    },
    {
      "id": "_results",
      "kind": "expression-prefix",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/expression-prefix-v1.ttl",
      "description": "Named result of a prior ActionFlow step"
    },
    {
      "id": "appData",
      "kind": "expression-prefix",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/expression-prefix-v1.ttl",
      "description": "App-wide shared state. Read-mostly from any block; mutations through dedicated actions."
    },
    {
      "id": "computed",
      "kind": "expression-prefix",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/expression-prefix-v1.ttl",
      "description": "Derived/reactive values recomputed from dependencies"
    },
    {
      "id": "env",
      "kind": "expression-prefix",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/expression-prefix-v1.ttl",
      "description": "Build-time and runtime configuration (e.g. API base URL, feature flags). Read-only."
    },
    {
      "id": "event",
      "kind": "expression-prefix",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/expression-prefix-v1.ttl",
      "description": "Event payload from UI event binding"
    },
    {
      "id": "item",
      "kind": "expression-prefix",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/expression-prefix-v1.ttl",
      "description": "Current item in iterateOver iteration context"
    },
    {
      "id": "local",
      "kind": "expression-prefix",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/expression-prefix-v1.ttl",
      "description": "Component-local state (per-block)"
    },
    {
      "id": "props",
      "kind": "expression-prefix",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/expression-prefix-v1.ttl",
      "description": "External inputs from parent block or page"
    },
    {
      "id": "route",
      "kind": "expression-prefix",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/expression-prefix-v1.ttl",
      "description": "Current routing context (path, query, params, hash). Read-only; injected by router."
    },
    {
      "id": "action",
      "kind": "flow-step",
      "scope": "platform",
      "source": "ontology/flow-step-types.json",
      "description": "Execute a single action (alias for basic, used by bundle-injected flows)"
    },
    {
      "id": "basic",
      "kind": "flow-step",
      "scope": "platform",
      "source": "ontology/flow-step-types.json",
      "description": "Execute a single action with params"
    },
    {
      "id": "conditional",
      "kind": "flow-step",
      "scope": "platform",
      "source": "ontology/flow-step-types.json",
      "description": "Branch execution based on condition"
    },
    {
      "id": "expression",
      "kind": "flow-step",
      "scope": "platform",
      "source": "ontology/flow-step-types.json",
      "description": "Evaluate expression and optionally store result"
    },
    {
      "id": "loop",
      "kind": "flow-step",
      "scope": "platform",
      "source": "ontology/flow-step-types.json",
      "description": "Iterate over a collection"
    },
    {
      "id": "parallel",
      "kind": "flow-step",
      "scope": "platform",
      "source": "ontology/flow-step-types.json",
      "description": "Execute multiple steps concurrently"
    },
    {
      "id": "saga",
      "kind": "flow-step",
      "scope": "platform",
      "source": "ontology/flow-step-types.json",
      "description": "Ordered stages with reverse compensation of completed stages on failure"
    },
    {
      "id": "stage",
      "kind": "flow-step",
      "scope": "platform",
      "source": "ontology/flow-step-types.json",
      "description": "Ordered lifecycle boundary; not an ACID database transaction"
    },
    {
      "id": "switch",
      "kind": "flow-step",
      "scope": "platform",
      "source": "ontology/flow-step-types.json",
      "description": "Multi-branch switch on value"
    },
    {
      "id": "tryCatch",
      "kind": "flow-step",
      "scope": "platform",
      "source": "ontology/flow-step-types.json",
      "description": "Error handling and guaranteed cleanup with try/catch/finally blocks"
    },
    {
      "id": "init",
      "kind": "flow-trigger",
      "scope": "platform",
      "source": "ontology/flow-step-types.json"
    },
    {
      "id": "lifecycle",
      "kind": "flow-trigger",
      "scope": "platform",
      "source": "ontology/flow-step-types.json"
    },
    {
      "id": "mount",
      "kind": "flow-trigger",
      "scope": "platform",
      "source": "ontology/flow-step-types.json"
    },
    {
      "id": "onBlockLoad",
      "kind": "flow-trigger",
      "scope": "platform",
      "source": "ontology/flow-step-types.json"
    },
    {
      "id": "onLoad",
      "kind": "flow-trigger",
      "scope": "platform",
      "source": "ontology/flow-step-types.json"
    },
    {
      "id": "onMount",
      "kind": "flow-trigger",
      "scope": "platform",
      "source": "ontology/flow-step-types.json"
    },
    {
      "id": "unmount",
      "kind": "flow-trigger",
      "scope": "platform",
      "source": "ontology/flow-step-types.json"
    },
    {
      "id": "accept",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): fileUpload, openNativeFilePicker, pickFiles"
    },
    {
      "id": "accuracy",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): geolocation"
    },
    {
      "id": "action",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): debounceAction, queueAction, retryAction, throttleAction, websocket"
    },
    {
      "id": "actions",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): batchAction, showPopup, transactionAction"
    },
    {
      "id": "agentRef",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): invokeNativeSignatureAgent"
    },
    {
      "id": "algorithm",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): cryptoAction"
    },
    {
      "id": "apiKey",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): geminiAction, geminiFunctionCall, geminiVision"
    },
    {
      "id": "args",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): invokeCallback"
    },
    {
      "id": "audio",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): mediaCapture"
    },
    {
      "id": "await",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): callFlow"
    },
    {
      "id": "baseDelay",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): retryAction"
    },
    {
      "id": "behavior",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): scrollToElement, scrollToPosition"
    },
    {
      "id": "body",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): loadDatasource, notification, restApi"
    },
    {
      "id": "callback",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): invokeCallback"
    },
    {
      "id": "callbackId",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): invokeCallback"
    },
    {
      "id": "cancelLabel",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): confirmAction"
    },
    {
      "id": "columns",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): csvExport"
    },
    {
      "id": "condition",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): conditionalDelay"
    },
    {
      "id": "confirmLabel",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): confirmAction"
    },
    {
      "id": "connectionId",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): websocket"
    },
    {
      "id": "context",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): callFlow"
    },
    {
      "id": "credentials",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): restApi"
    },
    {
      "id": "dangerous",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): confirmAction"
    },
    {
      "id": "data",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): analyticsEvent, cryptoAction, csvExport, emitEvent, jsonExport, log, websocket"
    },
    {
      "id": "datasourceId",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): loadDatasource, uploadFiles"
    },
    {
      "id": "delay",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): debounceAction, retryAction"
    },
    {
      "id": "description",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): showToast"
    },
    {
      "id": "direction",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): sortByField"
    },
    {
      "id": "duration",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): conditionalDelay, delay"
    },
    {
      "id": "durationMs",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): showToast"
    },
    {
      "id": "endpoint",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): graphqlAction, restApi"
    },
    {
      "id": "event",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): analyticsEvent, emitEvent"
    },
    {
      "id": "eventName",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): emitEvent"
    },
    {
      "id": "exposedActions",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): geminiAction"
    },
    {
      "id": "expression",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): compute, computeField"
    },
    {
      "id": "field",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): computeField, fileUpload, setTableCell, sortByField"
    },
    {
      "id": "filename",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): csvExport, downloadAction, jsonExport"
    },
    {
      "id": "files",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): shareAction, uploadFiles"
    },
    {
      "id": "flow",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): callFlow"
    },
    {
      "id": "flowName",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): callFlow"
    },
    {
      "id": "handler",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): dispatchStoreAction"
    },
    {
      "id": "headers",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): downloadAction, graphqlAction, restApi"
    },
    {
      "id": "imageBase64",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): geminiVision"
    },
    {
      "id": "imageId",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): cropImage"
    },
    {
      "id": "images",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): geminiVision"
    },
    {
      "id": "imageUrl",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): geminiVision"
    },
    {
      "id": "interval",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): throttleAction"
    },
    {
      "id": "key",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): cryptoAction, debounceAction, storage, throttleAction"
    },
    {
      "id": "keyField",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): groupBy"
    },
    {
      "id": "keySlice",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): groupBy"
    },
    {
      "id": "leading",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): debounceAction"
    },
    {
      "id": "level",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): log"
    },
    {
      "id": "match",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): setState"
    },
    {
      "id": "maxDuration",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): mediaCapture"
    },
    {
      "id": "maxRetries",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): retryAction"
    },
    {
      "id": "maxSize",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): fileUpload"
    },
    {
      "id": "maxToolCalls",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): geminiAction"
    },
    {
      "id": "maxTurns",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): geminiFunctionCall"
    },
    {
      "id": "maxWait",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): conditionalDelay, debounceAction"
    },
    {
      "id": "message",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): confirmAction, log, showLoading, showPopup, showToast"
    },
    {
      "id": "method",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): invokeNativeSignatureAgent, loadDatasource, restApi"
    },
    {
      "id": "mimeType",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): geminiVision"
    },
    {
      "id": "mode",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): navigate"
    },
    {
      "id": "model",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): geminiAction, geminiFunctionCall, geminiVision"
    },
    {
      "id": "ms",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): conditionalDelay, delay"
    },
    {
      "id": "multiple",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): openNativeFilePicker, pickFiles"
    },
    {
      "id": "name",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): emitEvent, setVariable"
    },
    {
      "id": "newTab",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): goLink"
    },
    {
      "id": "onMatch",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): setState"
    },
    {
      "id": "onNew",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): setState"
    },
    {
      "id": "operation",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): cryptoAction, setState, storage"
    },
    {
      "id": "overlay",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): showLoading"
    },
    {
      "id": "params",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): debounceAction, dispatchStoreAction, invokeCallback, navigate, queueAction, retryAction, throttleAction"
    },
    {
      "id": "payload",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): emitEvent, invokeNativeSignatureAgent"
    },
    {
      "id": "pollInterval",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): conditionalDelay"
    },
    {
      "id": "position",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): addTableRow"
    },
    {
      "id": "predicate",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): setState"
    },
    {
      "id": "priority",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): queueAction"
    },
    {
      "id": "prompt",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): geminiAction, geminiFunctionCall, geminiVision"
    },
    {
      "id": "quality",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): mediaCapture"
    },
    {
      "id": "query",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): graphqlAction, loadDatasource"
    },
    {
      "id": "queue",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): queueAction"
    },
    {
      "id": "queueId",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): queueAction"
    },
    {
      "id": "range",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): computeDateRange"
    },
    {
      "id": "ratio",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): cropImage"
    },
    {
      "id": "reason",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): stopFlow"
    },
    {
      "id": "redirectUrl",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): openAuthSession"
    },
    {
      "id": "responseKey",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): restApi"
    },
    {
      "id": "resultKey",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): restApi"
    },
    {
      "id": "resultPath",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): clipboardRead, cryptoAction, fileUpload, geolocation, graphqlAction, mediaCapture, pickFiles, storage"
    },
    {
      "id": "resultTarget",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): csvExport, geminiAction, geminiFunctionCall, geminiVision, graphqlAction, invokeNativeSignatureAgent, jsonExport, loadDatasource, openAuthSession, pickFiles, restApi, transactionAction, uploadF…"
    },
    {
      "id": "retryPolicy",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): restApi"
    },
    {
      "id": "rollback",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): transactionAction"
    },
    {
      "id": "route",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): navigate"
    },
    {
      "id": "row",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): addTableRow"
    },
    {
      "id": "rowIndex",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): deleteTableRow, setTableCell"
    },
    {
      "id": "rules",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): validate"
    },
    {
      "id": "scope",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): setVariable"
    },
    {
      "id": "sectionId",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): scrollToElement"
    },
    {
      "id": "secure",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): storage"
    },
    {
      "id": "show",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): showLoading"
    },
    {
      "id": "smooth",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): scrollToElement, scrollToPosition"
    },
    {
      "id": "source",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): computeField, groupBy, loadDatasource, mediaCapture, sortByField, uploadFiles"
    },
    {
      "id": "statePrefix",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): computeDateRange"
    },
    {
      "id": "steps",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): transactionAction"
    },
    {
      "id": "stopOnError",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): batchAction"
    },
    {
      "id": "sumFields",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): groupBy"
    },
    {
      "id": "systemPrompt",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): geminiFunctionCall"
    },
    {
      "id": "target",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): addTableRow, compute, computeField, deleteTableRow, groupBy, loadDatasource, navigate, restApi, scrollToElement, setState, setTableCell, setVariable, sortByField, uploadFiles, validate"
    },
    {
      "id": "text",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): copyToClipboard, shareAction"
    },
    {
      "id": "theme",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): setTheme"
    },
    {
      "id": "throwOnHttpError",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): restApi"
    },
    {
      "id": "timeout",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): geolocation, restApi"
    },
    {
      "id": "title",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): confirmAction, notification, shareAction, showPopup, showToast"
    },
    {
      "id": "to",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): navigate"
    },
    {
      "id": "tokenBudget",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): geminiFunctionCall"
    },
    {
      "id": "tools",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): geminiFunctionCall"
    },
    {
      "id": "trailing",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): debounceAction"
    },
    {
      "id": "transition",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): navigate"
    },
    {
      "id": "type",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): mediaCapture, showPopup"
    },
    {
      "id": "unit",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): delay"
    },
    {
      "id": "update",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): setState"
    },
    {
      "id": "url",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): downloadAction, fileUpload, goLink, graphqlAction, openAuthSession, restApi, shareAction, websocket"
    },
    {
      "id": "value",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): compute, copyToClipboard, log, setState, setTableCell, setVariable, showLoading, storage"
    },
    {
      "id": "variables",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): graphqlAction"
    },
    {
      "id": "variant",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): showToast"
    },
    {
      "id": "wait",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): debounceAction"
    },
    {
      "id": "y",
      "kind": "param-key",
      "scope": "platform",
      "source": "packages/cogo-kg-browser/fixtures/actionflow-executors-v1.ttl",
      "description": "ActionFlow parameter declared by executor(s): scrollToPosition"
    },
    {
      "id": "expression_difference_in_days",
      "kind": "surface-term",
      "scope": "platform",
      "source": "ontology/platform-decision-terms.seed.json",
      "category": "naming-rule",
      "description": "두 날짜 사이의 부호 있는 일수 차이 — GlobalFn differenceInDays(dateLeft, dateRight): number. dateLeft가 나중이면 양수(date-fns 관례 그대로, 0으로 절단), 인자는 ISO 날짜 문자열(YYYY-MM-DD/타임스탬프) 또는 epoch-ms, 파싱 불가 시 null(GlobalFn fail-soft 관례). 절대값은 Math.abs 조합. 프라이어 조사: 모델은 이름…",
      "terms": [
        "difference in days",
        "differenceInDays",
        "날짜 차이(일)"
      ],
      "ontologyRefs": [
        "expression-accessor:differenceInDays"
      ]
    },
    {
      "id": "ku:woori-fe-guide-v0.1:design-vs-dev-screen-id",
      "kind": "surface-term",
      "scope": "platform",
      "source": "ontology/knowledge-units.seed.json",
      "category": "mapping",
      "description": "디자인 소스(.fig)의 화면 식별 체계(`NMWF1009` 등 프레임명, UX 스토리보드 `F70407` 계열)와 개발 화면ID 체계(`NW[L4]…`)는 서로 다른 채번이므로 소스→앱 변환 시 명시적 매핑 테이블이 필요하다.",
      "terms": [
        "F70407",
        "NMWF1009",
        "화면ID 매핑"
      ]
    },
    {
      "id": "ku:woori-fe-guide-v0.1:no-dynamic-routing",
      "kind": "surface-term",
      "scope": "platform",
      "source": "ontology/knowledge-units.seed.json",
      "category": "prohibition",
      "description": "Next.js 동적 라우팅 사용 절대 금지 (pages 라우터, 파일명이 URL 경로).",
      "terms": [
        "Next.js",
        "동적 라우팅"
      ]
    },
    {
      "id": "ku:woori-fe-guide-v0.1:screen-id-format",
      "kind": "surface-term",
      "scope": "platform",
      "source": "ontology/knowledge-units.seed.json",
      "category": "naming-rule",
      "description": "개발 화면ID는 `NW[L4코드][5자리 시퀀스]_[3자리][화면유형구분자]` 형식이며 경로는 `/[L5]/[업무ID]/[화면ID]` (예: `NWTSW00001_001M`, `/src/pages/ist/NWTSW00001/NWTSW00001_001M.tsx`).",
      "terms": [
        "L4",
        "L5",
        "NWTSW00001_001M",
        "화면ID"
      ]
    },
    {
      "id": "ku:woori-fe-guide-v0.1:usemofetch-auto-tx",
      "kind": "surface-term",
      "scope": "platform",
      "source": "ontology/knowledge-units.seed.json",
      "category": "api-contract",
      "description": "자동 거래호출은 `useMOFetch`(마운트 시 자동 실행) — fetchControl.activated=false로 지연 후 true 전환 시 즉시 호출, options에 multipart/blocking/allowVolley/manualErrorHandle/timeout, v2는 observeParams로 inData 변화 재호출·페이징 지원.",
      "terms": [
        "observeParams",
        "useMOFetch",
        "자동거래호출"
      ]
    },
    {
      "id": "ku:woori-fe-guide-v0.1:usemotx-manual-tx",
      "kind": "surface-term",
      "scope": "platform",
      "source": "ontology/knowledge-units.seed.json",
      "category": "api-contract",
      "description": "수동 거래호출은 `useMOTx<Res,Req>(\"[L4]\",\"/[L5]/[controller]/[method]\", txControl?, options?)` — L4/경로 문자열은 영향도 분석을 위해 하드코딩 필수(변수 매핑 시 ESLint 에러), options에 blocking/manualErrorHandle/onBefore/onSuccess/onError/onComplete.",
      "terms": [
        "L4",
        "useMOTx",
        "거래호출"
      ]
    },
    {
      "id": "table_column_sort_toggle",
      "kind": "surface-term",
      "scope": "platform",
      "source": "ontology/platform-decision-terms.seed.json",
      "category": "naming-rule",
      "description": "컬럼 헤더 클릭으로 해당 컬럼 기준 오름차순/내림차순 정렬을 토글한다 — DataTableColumn.sortable: true. 이름은 TanStack Table/AntD의 column-level sortable 관례에서 채택(프라이어 정렬); sortKey는 key와 중복되어 admission 대상에서 제외됐다. 렌더러는 기존 sortColumn/sortDirection 정렬 로직(이전에는 저작/바인딩된 값으로만 도달 가…",
      "terms": [
        "column sort toggle",
        "sortable",
        "컬럼 정렬 토글"
      ],
      "ontologyRefs": [
        "element-type:data-table"
      ]
    },
    {
      "id": "table_conditional_row_highlight",
      "kind": "surface-term",
      "scope": "platform",
      "source": "ontology/platform-decision-terms.seed.json",
      "category": "naming-rule",
      "description": "행 데이터가 조건식을 만족할 때 해당 행에 스타일 클래스를 적용한다 — DataTable.rowClassRules: [{ when: \"#{item.<field> <op> <appData.|local.|props.|computed.><symbol>}\", className }]. 이름은 AG Grid의 rowClassRules 관례에서 채택(프라이어 정렬), 값은 cogo #{} 표현식 관용구로 실현한다.",
      "terms": [
        "conditional row highlight",
        "rowClassRules",
        "조건부 행 강조"
      ],
      "ontologyRefs": [
        "element-type:data-table"
      ]
    },
    {
      "id": "toast_title_heading",
      "kind": "surface-term",
      "scope": "platform",
      "source": "ontology/platform-decision-terms.seed.json",
      "category": "api-contract",
      "description": "showToast 액션의 title 파라미터는 토스트의 헤딩(제목)을 렌더한다 — message/description은 그 아래 본문으로 렌더된다. title 미지정 시 message가 헤딩으로 쓰이는 기존(pre-admission) 동작과 완전히 하위호환. 실행기: actionShowToast(cogo-runtime-v2/src/action-flow-engine.ts). action-types.json은 이미 title을 …",
      "terms": [
        "showToast.title",
        "toast title",
        "토스트 제목"
      ],
      "ontologyRefs": [
        "action-type:showToast"
      ]
    }
  ]
}
